///iam/v4/iam/organizations/my
import { create } from 'zustand';
import type { IMyOgnization } from './type';

export interface CurrentOrganization {
  itemId: string;
  name: string;
}

interface MyOgnizationState {
  organization: IMyOgnization | null;
  setOgnization: (organization: IMyOgnization) => void;
  clearOrgnization: () => void;
  currentOrganization: CurrentOrganization | null;
  setCurrentOrganization: (org: string | CurrentOrganization) => void;
  clearCurrentOrganization: () => void;
}

const resolveCurrentOrganization = (
  organizations: IMyOgnization['organizations'] | undefined,
  org: string | CurrentOrganization,
  previous: CurrentOrganization | null
): CurrentOrganization => {
  if (typeof org !== 'string') {
    const listed = organizations?.find((item) => item.itemId === org.itemId);
    return {
      itemId: org.itemId,
      name: listed?.name || org.name,
    };
  }

  const listed = organizations?.find((item) => item.itemId === org);
  if (listed) {
    return { itemId: listed.itemId, name: listed.name };
  }

  if (previous?.itemId === org) {
    return previous;
  }

  return { itemId: org, name: org };
};

export const useMyOgnizationStore = create<MyOgnizationState>()((set) => ({
  organization: null,
  currentOrganization: null,
  setCurrentOrganization: (org) =>
    set((state) => ({
      currentOrganization: resolveCurrentOrganization(
        state.organization?.organizations,
        org,
        state.currentOrganization
      ),
    })),
  clearCurrentOrganization: () => set({ currentOrganization: null }),
  setOgnization: (organization) =>
    set((state) => {
      const currentId = state.currentOrganization?.itemId;
      const listed = currentId
        ? organization.organizations.find((item) => item.itemId === currentId)
        : undefined;
      return {
        organization,
        currentOrganization: listed
          ? { itemId: listed.itemId, name: listed.name }
          : state.currentOrganization,
      };
    }),
  clearOrgnization: () => set({ organization: null, currentOrganization: null }),
}));

export const getCurrentOrgId = () =>
  useMyOgnizationStore.getState().currentOrganization?.itemId ?? null;

export const useCurrentOrgId = () =>
  useMyOgnizationStore((state) => state.currentOrganization?.itemId ?? null);
